import { render } from "./Pdf-Recibo.vue?vue&type=template&id=4fe9c8da&scoped=true"
import script from "./Pdf-Recibo.vue?vue&type=script&lang=js"
export * from "./Pdf-Recibo.vue?vue&type=script&lang=js"

import "./Pdf-Recibo.vue?vue&type=style&index=0&id=4fe9c8da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe9c8da"]])

export default __exports__